import React from 'react'
import { array, bool, func, shape, string } from 'prop-types'
import { connect } from 'react-redux'

import ContentModal from '../ContentModal'
import { ContentModalCtrl } from '../ContentModalSection'
import FormAskQuestion from '../ContentForms/AskQuestion'
import FormTestDrive from '../ContentForms/TestDrive'
import CalltracksPhoneNumber from '../CalltracksPhoneNumber'

class ContentModalHowCanWeHelp extends React.PureComponent {
  render() {
    const {
      phoneNumber,
      open,
      onClose,
      vehicleId,
      locations,
      isTestDriveOpen,
      onTestDriveOpen,
      onTestDriveClose,
      location,
      registration,
      isAskQuestionOpen,
      onAskQuestionOpen,
      onAskQuestionClose,
      brand,
      model,
      brandSpecific,
      locationInfo,
      isNewVehicle
    } = this.props

    return (
      <ContentModal
        title="How can we help?"
        subtitle={
          <CalltracksPhoneNumber
            phoneNumber={phoneNumber.phoneNumber}
            calltracksClass={phoneNumber.calltracksClass}
          />
        }
        summary="Use the links below to register interest or ask a question and a member of our team will be in contact shortly."
        slim
        open={open}
        onClose={onClose}
      >
        <ContentModalCtrl
          sections={[
            {
              default: 'I want to register my interest',
              active: 'Please fill in your details below',
              content: (
                <FormTestDrive
                  vehicleId={vehicleId}
                  locations={locations}
                  location={locationInfo}
                  brand={brand}
                  model={model}
                  brandSpecific={brandSpecific}
                  newVehicle={isNewVehicle}
                />
              ),
              info: false,
              isOpen: isTestDriveOpen,
              onOpen: onTestDriveOpen,
              onClose: onTestDriveClose
            },
            {
              default: 'I’d like to ask a question',
              active: 'Please fill in your details below',
              content: (
                <FormAskQuestion
                  brand={brand}
                  model={model}
                  location={location}
                  registration={registration}
                />
              ),
              isOpen: isAskQuestionOpen,
              onOpen: onAskQuestionOpen,
              onClose: onAskQuestionClose
            }
          ]}
        />
      </ContentModal>
    )
  }
}

ContentModalHowCanWeHelp.defaultProps = {
  onAskQuestionOpen: () => {},
  onTestDriveOpen: () => {}
}

ContentModalHowCanWeHelp.propTypes = {
  phoneNumber: shape({ link: string, phoneNumber: string }),
  open: bool,
  onClose: func,
  vehicleId: string,
  locations: array,
  isTestDriveOpen: bool,
  onTestDriveOpen: func,
  onTestDriveClose: func,
  location: string,
  registration: string,
  isAskQuestionOpen: bool,
  onAskQuestionOpen: func,
  onAskQuestionClose: func,
  brandSpecific: bool,
  brand: string,
  model: string
}

export default connect((state) => ({ phoneNumber: state.phoneNumber }))(
  ContentModalHowCanWeHelp
)
